import { API_URL } from "../config/environment";
import secureLocalStorage from "react-secure-storage";

const token = sessionStorage.getItem("authToken");

export async function refreshIngredients() {
  const url = `${API_URL}/ingredients?page=0&offset=15&technofunctionality=Agent emulsifiant`;

  try {
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    if (data.status === "success") {
      const ingredients = data.ingredients;
      const _ingredients = JSON.stringify(ingredients);
      secureLocalStorage.setItem("ingredients", _ingredients);
      return true;
    } else {
      console.log("Could not fetch data from server");
      return false;
    }
  } catch (error) {
    console.log("Error fetching ingredients");
    return false;
  }
}

export async function refreshIngredientsMetrics() {
  const url = `${API_URL}/ingredients/metrics`;
  try {
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await response.json();

    if (data.status === "success") {
      let ingredientsMetrics = data.ingredientsMetrics;

      ingredientsMetrics = restructureMetricsData(ingredientsMetrics);
      const _ingredientsMetrics = JSON.stringify(ingredientsMetrics);
      secureLocalStorage.setItem("ingredientsMetrics", _ingredientsMetrics);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.log("Error fetching ingredients from server");
    return false;
  }
}

function restructureMetricsData(metrics) {
  metrics = metrics?.map((metric) => {
    const metricsData = {
      categories: ["Sectors", "ProductPlaforms", "Ingredients"],
      series: [
        {
          name: "sectors",
          data: metric.metrics.sectorMetrics,
        },
        {
          name: "productPlatform",
          data: metric.metrics.productPlatformMetrics,
        },
        {
          name: "ingredients",
          data: metric.metrics.ingredientMetrics,
        },
      ],
    };

    return { name: metric.name, metricsData };
  });

  return metrics;
}
